import Cookies from "js-cookie";
import TokenService from "../../services/token.service";

export const finalizeLogin = ({ responseApi, pParam = null, navigate = null, setGlobalValue = null, reloadAfterNavigate = false }) => {
  const payload = responseApi || {};
  const restricoes = payload.restricoes || [];
  const queryParam = restricoes.length > 1 ? "?definir_acesso=1" : "";

  localStorage.removeItem("globalContextValue");

  if (restricoes.length > 0 && restricoes[0]?.trocar_senha) {
    localStorage.setItem("trocar_senha", 1);
  }

  if (pParam) {
    Cookies.set("p_login", pParam, { secure: true, sameSite: "Strict", path: "/" });
  }

  TokenService.setUser(payload);

  if (typeof setGlobalValue === "function") {
    const { access, refresh, ...userWithoutTokens } = payload;
    setGlobalValue({
      user: userWithoutTokens,
      programaId: pParam || null,
      timestamp: new Date().getTime(),
    });
  }

  const targetPath = `/${queryParam}`;

  if (typeof navigate === "function") {
    navigate(targetPath);
    if (reloadAfterNavigate) {
      window.location.reload();
    }
    return;
  }

  window.location.href = targetPath;
};
